import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTiposTecnicoState,
  entityTiposTecnicoAdapter
} from './entity-tipos-tecnico.state';
import {
  entityTiposTecnicoLoadFailure,
  entityTiposTecnicoLoadRequest,
  entityTiposTecnicoLoadSuccess
} from './entity-tipos-tecnico.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTiposTecnicoLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTiposTecnicoLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTiposTecnicoLoadSuccess, (state, { items }) =>
    entityTiposTecnicoAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function tiposTecnicoReducer(
  state: EntityTiposTecnicoState | undefined,
  action: Action
) {
  return reducer(state, action);
}
